const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { MediaUpload, InspectorControls } = wp.blockEditor;
const { useSelect } = wp.data;
const { TextControl, Panel, PanelBody, PanelRow, Icon } = wp.components;
const { serverSideRender: ServerSideRender } = wp;
import { useState } from "react";

const { __experimentalLinkControlSearchInput: LinkControlSearchInput } =
	wp.blockEditor;

registerBlockType(
	"qteblocks/block-instagram-feed", // Name of the block with a required name space
	{
		title: "Instagram feed block",
		description: "Visar de Instagram feed",
		icon: "editor-ul", // Icon, from WP icons
		category: "qteblocks",

		attributes: {
			title: {
				type: "string",
				default: "",
			},
		},

		edit(props) {
			var attributes = props.attributes;
			const suggestionsRender = (props) => (
				<div className="components-dropdown-menu__menu">
					{props.suggestions.map((suggestion, index) => {
						return (
							<div
								onClick={() => props.handleSuggestionClick(suggestion)}
								className="components-button components-dropdown-menu__menu-item is-active has-text has-icon"
							>
								{suggestion.title}
							</div>
						);
					})}
				</div>
			);

			return (
				<>
					<InspectorControls>
						<Panel>
							<PanelBody
								title="Blockinställningar"
								icon={<Icon icon="admin-generic" />}
								initialOpen={true}
							>
								<PanelRow>
									<TextControl
										label="Titel"
										value={attributes.title}
										onChange={(value) => props.setAttributes({ title: value })}
									/>
								</PanelRow>
							</PanelBody>
						</Panel>
					</InspectorControls>
					<ServerSideRender
						block="qteblocks/block-instagram-feed"
						attributes={props.attributes}
					/>
				</>
			);
		},

		save(props) {
			return null; // See PHP side. This block is rendered on PHP.
		},
	},
);
